import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import React from "react";
import { useTenant } from "../../Context/TenantProvider";
import { CountryCode } from "../../../utils/CountryCode";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    button: {
        "&.MuiToggleButton-root.Mui-selected": {
            backgroundColor: '#FFEC0F !important'
        },
        "&.MuiToggleButton-root": {
            backgroundColor: '#d4d4d4 !important'
        }
    },
}))

export const LocationSelection: React.FC = () => {
    const classes = useStyles();
    const { currentCountry, switchCountry } = useTenant();

    const handleSwitch = (newValue: string | null) => {
        if (newValue !== null) {
            switchCountry(newValue as CountryCode);
        }
    }
    return (
        <>
            <ToggleButtonGroup
                value={currentCountry}
                exclusive
                onChange={(e, value) => handleSwitch(value)}
            >
                <ToggleButton className={classes.button} value="AU">AU</ToggleButton>
                <ToggleButton className={classes.button} value="NZ">NZ</ToggleButton>
            </ToggleButtonGroup>
        </>
    )
}